import React from 'react';
import { ListGroup, ListGroupItem } from 'reactstrap';

const CategoryList = ({ categories, onSelectCategory,activeCategory }) => {
    return (
      <ListGroup>
        {categories.map(category => (
          <ListGroupItem 
            key={category.id} 
            onClick={() => onSelectCategory(category)}
            tag="button"
            action
            active={activeCategory && activeCategory.id === category.id}
          >
            {category.category_name}
          </ListGroupItem>
        ))}
      </ListGroup>
    );
  };

  export default CategoryList;